import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { useAuth } from '../context/AuthContext';

export default function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  const { logout, name } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className={`gp-shell ${collapsed ? 'gp-collapsed' : ''}`}>
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />
      <div className="gp-main">
        <nav className="navbar bg-white border-bottom px-3">
          <button className="btn btn-outline-secondary me-2" onClick={() => setCollapsed((v) => !v)} aria-label="Alternar barra lateral">
            <i className="bi bi-list" />
          </button>
          <div className="ms-auto position-relative">
            <button
              type="button"
              className="btn btn-light border d-flex align-items-center gap-2"
              onClick={() => setMenuOpen((v) => !v)}
            >
              <i className="bi bi-person-circle text-primary" />
              <span className="text-dark">{name || 'Usuario'}</span>
              <i className="bi bi-caret-down-fill text-secondary" />
            </button>
            {menuOpen && (
              <div className="dropdown-menu show end-0 mt-2 p-0" style={{ display: 'block', position: 'absolute', right: 0 }}>
                <button className="dropdown-item" onClick={logout}>
                  <i className="bi bi-box-arrow-right me-2" /> Cerrar sesión
                </button>
              </div>
            )}
          </div>
        </nav>
        <div className="gp-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
